import { render, staticRenderFns } from "./BookingDetailPcp.vue?vue&type=template&id=5bdd3c38&scoped=true"
import script from "./BookingDetailPcp.vue?vue&type=script&lang=js"
export * from "./BookingDetailPcp.vue?vue&type=script&lang=js"
import style0 from "./BookingDetailPcp.vue?vue&type=style&index=0&id=5bdd3c38&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdd3c38",
  null
  
)

export default component.exports